import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const KEY = 'theme';

const readStored = () => {
  try { return localStorage.getItem(KEY); } catch (e) { return null; }
};

export const initialTheme = () => {
  const stored = readStored();
  if (stored === 'dark' || stored === 'light') return stored;
  try { return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'; } catch (e) { return 'light'; }
};

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle('dark', theme === 'dark');
};

/** Переключатель светлой/тёмной темы. Выбор запоминается в браузере. */
const ThemeToggle = () => {
  const { t } = useTranslation();
  const [theme, setTheme] = useState(initialTheme);
  useEffect(() => { applyTheme(theme); }, [theme]);
  const toggle = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    try { localStorage.setItem(KEY, next); } catch (e) { /* без сохранения тоже работает */ }
  };
  const label = theme === 'dark' ? t('pl.common.themeLight') : t('pl.common.themeDark');
  return (
    <button type="button" onClick={toggle} aria-label={label} title={label}
      className="fixed bottom-4 left-4 z-50 w-11 h-11 flex items-center justify-center rounded-full border-2 border-black bg-[#F5F1E8] shadow-lg hover:bg-white transition-colors">
      {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  );
};

export default ThemeToggle;
